export default __webpack_public_path__ + "static/media/gasag_xl3.2593ce76.png";